import { QueryClient } from '@tanstack/react-query';
import { Outlet, createRootRouteWithContext, useRouterState } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { ProtectedRoute } from '@/components/auth';
import { AppLayout } from '@/components/layout/AppLayout';

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

/**
 * Routes that don't require authentication or AppLayout.
 * These use their own layout (e.g., _auth layout).
 */
const PUBLIC_ROUTES = ['/sign-in', '/sign-up'];

function RootComponent() {
  const routerState = useRouterState();
  const pathname = routerState.location.pathname;
  const isPublicRoute = PUBLIC_ROUTES.some((route) => pathname.startsWith(route));

  // Public routes use their own layout via the _auth pathless layout
  if (isPublicRoute) {
    return (
      <>
        <Outlet />
        {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
      </>
    );
  }

  // Protected routes use AppLayout with authentication
  return (
    <ProtectedRoute>
      <AppLayout>
        <Outlet />
        {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
      </AppLayout>
    </ProtectedRoute>
  );
}
